/* OREN — Welle 9: Wishlist + Stock Alerts */
(function(){

  const WISHLIST_KEY = 'oren_wishlist';
  const ALERTS_KEY = 'oren_stock_alerts';

  function getList(key){
    try{ const v = localStorage.getItem(key); return v ? JSON.parse(v) : []; }
    catch(e){ return []; }
  }
  function setList(key, val){
    try{ localStorage.setItem(key, JSON.stringify(val)); }catch(e){}
  }

  /* ============================================
     WISHLIST — button on product pages
     ============================================ */
  function setupWishlistButton(){
    if(!document.body.classList.contains('template-product')) return;

    const productHandle = location.pathname.split('/products/')[1]?.split('/')[0]?.split('?')[0];
    if(!productHandle) return;

    let product;
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function(s){
      try{
        const d = JSON.parse(s.textContent);
        if(d['@type'] === 'Product') product = d;
      }catch(e){}
    });

    /* Find where to inject — after the form / add-to-cart button */
    const target = document.querySelector('product-form, .product-form, form[action*="/cart/add"]');
    if(!target) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oren-wishlist-btn';
    btn.setAttribute('data-cursor', 'Save');
    btn.innerHTML = '<span class="icon"></span><span class="label">Save to wishlist</span>';

    const wishlist = getList(WISHLIST_KEY);
    const alreadySaved = wishlist.some(function(w){ return w.handle === productHandle; });
    if(alreadySaved){
      btn.classList.add('saved');
      btn.querySelector('.label').textContent = 'Saved · In your wishlist';
    }

    btn.addEventListener('click', function(){
      const current = getList(WISHLIST_KEY);
      const existing = current.findIndex(function(w){ return w.handle === productHandle; });
      if(existing >= 0){
        current.splice(existing, 1);
        setList(WISHLIST_KEY, current);
        btn.classList.remove('saved');
        btn.querySelector('.label').textContent = 'Save to wishlist';
      }else{
        current.unshift({
          handle: productHandle,
          url: location.pathname,
          title: product?.name || document.title,
          image: (product?.image && product.image[0]) || '',
          price: product?.offers?.price || '',
          currency: product?.offers?.priceCurrency || 'EUR',
          code: product?.productID || '',
          ts: Date.now()
        });
        setList(WISHLIST_KEY, current.slice(0, 50));
        btn.classList.add('saved');
        btn.querySelector('.label').textContent = 'Saved · In your wishlist';
      }
      updateWishlistBadges();
    });

    target.parentNode.insertBefore(btn, target.nextSibling);
  }

  /* ============================================
     WISHLIST PAGE RENDERER
     ============================================ */
  function renderWishlistPage(){
    const container = document.querySelector('[data-wishlist-page]');
    if(!container) return;
    const list = getList(WISHLIST_KEY);
    const grid = container.querySelector('.oren-wishlist-grid');
    const empty = container.querySelector('.oren-wishlist-empty');

    if(list.length === 0){
      if(grid) grid.style.display = 'none';
      if(empty) empty.style.display = 'block';
      return;
    }

    if(empty) empty.style.display = 'none';
    if(grid) grid.style.display = 'grid';
    grid.innerHTML = list.map(function(item){
      const priceFormatted = item.price ? formatPrice(item.price, item.currency) : '';
      return '<div class="oren-wishlist-item-wrap" style="position:relative;">'+
        '<button class="remove" data-handle="' + escapeAttr(item.handle) + '" aria-label="Remove from wishlist">✕</button>'+
        '<a href="' + escapeAttr(item.url) + '" class="oren-wishlist-item" data-cursor="View">'+
          '<div class="img">' + (item.image ? '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.title) + '" loading="lazy">' : '') + '</div>'+
          '<div class="meta"><span class="code">' + escape(item.code) + '</span><span class="price">' + priceFormatted + '</span></div>'+
          '<div class="title">' + escape(item.title) + '</div>'+
        '</a>'+
      '</div>';
    }).join('');

    grid.querySelectorAll('.remove').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        const handle = b.getAttribute('data-handle');
        const updated = getList(WISHLIST_KEY).filter(function(w){ return w.handle !== handle; });
        setList(WISHLIST_KEY, updated);
        renderWishlistPage();
        updateWishlistBadges();
      });
    });
  }

  function updateWishlistBadges(){
    const count = getList(WISHLIST_KEY).length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  }

  /* ============================================
     STOCK ALERTS — on sold-out product pages
     ============================================ */
  function setupStockAlerts(){
    if(!document.body.classList.contains('template-product')) return;

    /* Detect sold out by checking for sold-out indicator */
    const soldOut = document.querySelector('[data-product-sold-out], .product-sold-out, .sold-out');
    const form = document.querySelector('form[action*="/cart/add"]');
    if(!form) return;

    /* Only inject alert if there's a sold-out signal */
    let isSoldOut = false;
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function(s){
      try{
        const d = JSON.parse(s.textContent);
        if(d['@type'] === 'Product' && d.offers && d.offers.availability && d.offers.availability.indexOf('OutOfStock') >= 0){
          isSoldOut = true;
        }
      }catch(e){}
    });

    if(!isSoldOut) return;

    const productHandle = location.pathname.split('/products/')[1]?.split('/')[0]?.split('?')[0];
    if(!productHandle) return;

    /* Check if user already subscribed */
    const alerts = getList(ALERTS_KEY);
    const alreadySubscribed = alerts.some(function(a){ return a.handle === productHandle; });

    const wrapper = document.createElement('div');
    wrapper.style.marginTop = '1em';
    wrapper.innerHTML =
      '<button type="button" class="oren-stock-alert ' + (alreadySubscribed ? 'subscribed' : '') + '" data-cursor="Notify">'+
        (alreadySubscribed ? 'You\u2019ll hear when it returns' : 'Notify me when it returns')+
      '</button>'+
      '<form class="oren-stock-alert-form" id="orenStockAlertForm">'+
        '<input type="email" name="email" placeholder="your-email@example.com" required autocomplete="email">'+
        '<button type="submit">Subscribe</button>'+
        '<div class="oren-stock-alert-info">We send one email when this piece is back in a delivery. Nothing else.</div>'+
      '</form>';

    form.parentNode.insertBefore(wrapper, form.nextSibling);

    const btn = wrapper.querySelector('.oren-stock-alert');
    const formEl = wrapper.querySelector('.oren-stock-alert-form');

    if(!alreadySubscribed){
      btn.addEventListener('click', function(){
        formEl.classList.toggle('visible');
      });

      formEl.addEventListener('submit', function(e){
        e.preventDefault();
        const email = formEl.querySelector('input[name="email"]').value;
        if(!email) return;

        /* Save locally + submit to Shopify customer form for backend collection */
        const current = getList(ALERTS_KEY);
        current.push({
          handle: productHandle,
          email: email,
          ts: Date.now()
        });
        setList(ALERTS_KEY, current);

        /* Submit to /contact endpoint with stock-alert tag for backend collection */
        const data = new FormData();
        data.append('form_type', 'customer');
        data.append('utf8', '✓');
        data.append('contact[email]', email);
        data.append('contact[tags]', 'stock-alert, ' + productHandle);
        data.append('contact[note]', 'Stock alert request for: ' + productHandle);

        fetch('/contact', { method: 'POST', body: data })
          .then(function(){
            btn.classList.add('subscribed');
            btn.textContent = 'You\u2019ll hear when it returns';
            formEl.classList.remove('visible');
          })
          .catch(function(){
            btn.classList.add('subscribed');
            btn.textContent = 'Saved · You\u2019ll hear when it returns';
            formEl.classList.remove('visible');
          });
      });
    }
  }

  /* ============================================
     UTILS
     ============================================ */
  function formatPrice(price, currency){
    try{
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR', maximumFractionDigits: 0 }).format(price);
    }catch(e){
      return (currency || 'EUR') + ' ' + price;
    }
  }
  function escape(s){
    return String(s || '').replace(/[&<>"\']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' }[c];
    });
  }
  function escapeAttr(s){ return escape(s); }

  /* ============================================
     INIT
     ============================================ */
  function init(){
    setupWishlistButton();
    renderWishlistPage();
    setupStockAlerts();
    updateWishlistBadges();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
